var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrosshairsGps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1327_3559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 5.33317C8.70708 5.33317 9.38536 5.61412 9.88546 6.11422C10.3856 6.61432 10.6665 7.29259 10.6665 7.99984C10.6665 8.70708 10.3856 9.38536 9.88546 9.88546C9.38536 10.3856 8.70708 10.6665 7.99984 10.6665C7.29259 10.6665 6.61432 10.3856 6.11422 9.88546C5.61412 9.38536 5.33317 8.70708 5.33317 7.99984C5.33317 7.29259 5.61412 6.61432 6.11422 6.11422C6.61432 5.61412 7.29259 5.33317 7.99984 5.33317ZM2.03317 8.6665H0.666504V7.33317H2.03317C2.33317 4.55317 4.55317 2.33317 7.33317 2.03317V0.666504H8.6665V2.03317C11.4465 2.33317 13.6665 4.55317 13.9665 7.33317H15.3332V8.6665H13.9665C13.6665 11.4465 11.4465 13.6665 8.6665 13.9665V15.3332H7.33317V13.9665C4.55317 13.6665 2.33317 11.4465 2.03317 8.6665ZM7.99984 3.33317C6.76216 3.33317 5.57518 3.82484 4.70001 4.70001C3.82484 5.57518 3.33317 6.76216 3.33317 7.99984C3.33317 9.23751 3.82484 10.4245 4.70001 11.2997C5.57518 12.1748 6.76216 12.6665 7.99984 12.6665C9.23751 12.6665 10.4245 12.1748 11.2997 11.2997C12.1748 10.4245 12.6665 9.23751 12.6665 7.99984C12.6665 6.76216 12.1748 5.57518 11.2997 4.70001C10.4245 3.82484 9.23751 3.33317 7.99984 3.33317Z",
    fill: "#29333D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1327_3559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshairsGps);
export default __webpack_public_path__ + "static/media/crosshairs-gps.e119aa424b8c226b4d0d32cd35c7c1de.svg";
export { ForwardRef as ReactComponent };